import { render, staticRenderFns } from "./ColunasData.vue?vue&type=template&id=3bfcf8b1&scoped=true&"
import script from "./ColunasData.vue?vue&type=script&lang=js&"
export * from "./ColunasData.vue?vue&type=script&lang=js&"
import style0 from "./ColunasData.vue?vue&type=style&index=0&id=3bfcf8b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcf8b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VItem,VItemGroup,VRow,VSpacer})
